import {Image, OwlCarousel} from "../../atoms/DependencyHelper";
import {useState, useEffect} from "react";
import PropTypes from "prop-types";
import config from "../../../config";

import styles from "./productViewer.module.scss";

const ProductViewer = ({mediaGallery, className, sku}) => {
  const [activeCounter, setActiveCounter] = useState(0);
  const [currentThumb, setCurrentThumb] = useState('');
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const removeDuplicates = (array) => {
    const uniqueUrls = new Set();
    return array.filter(item => {
      if (!uniqueUrls.has(item.url)) {
        uniqueUrls.add(item.url);
        return true;
      }
      return false;
    });
  };

  const uniqueImages = removeDuplicates(mediaGallery);

  const deviceOptions = {
    items: 1,
    nav: false,
    autoplay: false,
    center: true,
    animateIn: "animate__fadeIn",
    responsive: {
      0: {
        dots: true,
      },
      1024: {
        dots: false,
      },
    },
  };

  const thumbOptions = {
    autoplay: false,
    nav: false,
    autoWidth: true,
    lazyLoad: true,
    margin: 16,
    mouseDrag: false,
    responsive: {
      0: {
        dots: true,
        slideBy: 1,
      },
      1024: {
        dots: false
      },
    },
  };

  const events = {
    onTranslate: function (event) {
      setActiveCounter(event.item.index);
      setCurrentThumb(event.item.index);
      window.currentThumb = event.item.index;
    },
  };

  const thumbEvents = {
    onTranslate: function (event) {
      setActiveCounter(window.currentThumb);
    },
  };

  const next = () => {
    var imageCount = deviceCarousel.props.children.length;

    if (deviceCarousel.currentPosition + 1 > imageCount - 1) {
      deviceCarousel.goTo(0);
      thumbCarousel.goTo(0);
      setActiveCounter(0)

      return;
    }
    if (deviceCarousel) {
      deviceCarousel.next(600);
    }
    if (thumbCarousel) {
      thumbCarousel.goTo(
        deviceCarousel.currentPosition == mediaGallery?.length
          ? deviceCarousel.currentPosition + 1
          : deviceCarousel.currentPosition
      );
    }

    setActiveCounter(deviceCarousel.currentPosition)
  };
  const prev = () => {
    var imageCount = deviceCarousel.props.children.length;

    if (activeCounter - 1 < 0) {
      deviceCarousel.goTo(imageCount - 1);
      setActiveCounter(deviceCarousel.currentPosition)

      if (thumbCarousel) {
        thumbCarousel.goTo(deviceCarousel.currentPosition);
        thumbCarousel.currentPosition = deviceCarousel.currentPosition;
      }

      return;
    }

    if (deviceCarousel) {
      deviceCarousel.prev(600);
    }
    if (thumbCarousel) {
      thumbCarousel.goTo(deviceCarousel.currentPosition);
      thumbCarousel.currentPosition = deviceCarousel.currentPosition;
    }

    setActiveCounter(deviceCarousel.currentPosition)
  };
  const goTo = (index) => {
    if (deviceCarousel) {
      deviceCarousel.goTo(index);
    }
    if (thumbCarousel) {
      thumbCarousel.goTo(index);
    }
  };

  let deviceCarousel;
  let thumbCarousel;

  return (
    <div className={`${styles["product-viewer"]} ${className || ""}`}>
      <div className={styles["product-viewer__device"]}>
        {uniqueImages.length > 0 && (
          <>
            <div className={styles["carousel__prev"]} onClick={prev} id={`${sku}-next`}>
              <img src={`${imagePrefix}/assets/images/chevron-prev-white.svg`}/>
            </div>
            <OwlCarousel
              ref={(c) => (deviceCarousel = c)}
              options={deviceOptions}
              events={events}
            >
              {uniqueImages.map((thumbnail, index) => (
                <div key={index} className={styles["product-viewer__image"]}>
                  <Image
                    src={thumbnail.url}
                    alt={thumbnail.label}
                    id={`${index}-${thumbnail.label}`}
                  />
                </div>
              ))}
            </OwlCarousel>
            <div className={styles["carousel__next"]} onClick={next} id={`${sku}-next`}>
              <img src={`${imagePrefix}/assets/images/chevron-next-white.svg`}/>
            </div>
          </>
        )}
      </div>
      {uniqueImages.length > 0 && (
        <div className={`${styles["carousel"]} ${styles.thumbnailCarousel} ${uniqueImages.length > 6 ? styles.thumbMaxWidth : ''}`}>
          <div className={`${styles["carousel__container"]}`}>
            <OwlCarousel
              ref={(c) => (thumbCarousel = c)}
              options={thumbOptions}
              events={thumbEvents}
            >
              {uniqueImages.map((thumbnail, index) => {
                let prevThumbnail = uniqueImages[index === 0 ? 0 : index - 1].url;

                return (
                  (index >= 0) ?
                    <div
                      key={index}
                      onClick={() => goTo(index)}
                      data-url={prevThumbnail}
                      className={`${index !== 0 && prevThumbnail === thumbnail.url ? 'hidden' : 'not-hidden'} ${styles["thumbnail"]} ${
                        index === activeCounter ? styles["thumbnail--active"] : ""
                      }`}
                    >
                      <Image
                        src={thumbnail.url}
                        alt={thumbnail.label}
                        id={`${index}-${thumbnail.label}`}
                      />
                    </div>
                    : null
                );
              })}
            </OwlCarousel>
          </div>
        </div>
      )}
    </div>
  );
};

ProductViewer.propTypes = {
  mediaGallery: PropTypes.array,
  className: PropTypes.string,
  sku: PropTypes.string
};

export default ProductViewer;
